import React, { Component } from "react";
import { getCurrentMonthName, getMiddleDate } from "../../utils/helpers";
import dayjs from "dayjs";
import Select from "react-select";
class Form extends Component {
    state = {
        nombre: "",
        tipo: null,
        fecha_inicio: "",
        fecha_cierre: "",
        periodo: 'mensual',
        tipoEmpleados: '',
    };
    onChangeTipo = async (e) => {
        const tipo = e.target.value;

        await this.setState({
            tipo: tipo,
            periodo: tipo === 'FIJOS' ? 'quincenal' : 'mensual',
        });

        const fechas = this.getFechas();

        this.setState({
            fecha_inicio: fechas.inicio,
            fecha_cierre: fechas.cierre,
            nombre: this.getNombre(tipo, dayjs()),
        });
    };

    onChangeEmpleados = async (e) => {
        if (!e.value) return;

        await this.setState({
            tipoEmpleados: e.label,
        });

        this.setState({
            nombre: this.getNombre(this.state.tipo, dayjs()),
        });
    };

    getNombre = (tipo, fecha) => {
        const { periodo, tipoEmpleados } = this.state;
        const month = getCurrentMonthName(fecha.month());
        const year = fecha.year();

        if (periodo === 'mensual') {
            return (
                month + " " + fecha.year() + " - " + tipo + " " + tipoEmpleados
            );
        } else {
            if (fecha.date() > 15) {
                return `${month} ${year} - ${tipo} ${tipoEmpleados} - 2da Quincena`;
            } else {
                return `${month} ${year} - ${tipo} ${tipoEmpleados} - 1ra Quincena`;
            }
        }
    };
    getFechas = () => {
        const {periodo} = this.state;
        let inicio, cierre;

        if (periodo === 'mensual') {
            inicio = dayjs().startOf("month").format("YYYY-MM-DD");
            cierre = dayjs().endOf("month").format("YYYY-MM-DD");
        } else {
            if (dayjs().date() > 15) {
                inicio = getMiddleDate();
                cierre = dayjs().endOf("month").format("YYYY-MM-DD");
            } else {
                inicio = dayjs().startOf("month").format("YYYY-MM-DD");
                cierre = getMiddleDate();
            }
        }

        return { inicio, cierre };
    };
    onChangeNombre = (e) => {
        this.setState({
            nombre: e.target.value,
        });
    };
    onChangePeriodo = async (e) => {
        await this.setState({
            periodo: e.target.value,
        });

        const fechas = this.getFechas();

        this.setState({
            nombre: this.getNombre(this.state.tipo, dayjs()),
            fecha_inicio: fechas.inicio,
            fecha_cierre: fechas.cierre,
        });
    };
    onChangeDate = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });

        if (e.target.name === "fecha_inicio") {
            this.setState({
                nombre: this.getNombre(this.state.tipo, dayjs(e.target.value)),
            });
        }
    };
    render() {
        const { nombre, tipo, fecha_inicio, fecha_cierre, periodo } = this.state;
        const { nomina, errors, tiposEmpleados } = this.props;
        const tiposSeleccionados = tiposEmpleados
            .filter((t) => {
                const compare = tipo === "FIJOS" ? "fijo" : "produccion";

                if (compare === 'fijo') {
                    return t.tipoNomina === compare;
                }

                return t.tipoNomina.indexOf(compare) > -1;
            })
            .map((t) => {
                return {
                    label: t.nombre,
                    value: t.id,
                };
            });

        return (
            <div>
                <div className='row form-group'>
                    <div className='col col-md-4'>
                        <label className='label form-control-label'>
                            Tipo Nómina:
                        </label>
                    </div>
                    <div className='col col-md-8'>
                        <select
                            className='text-input form-control'
                            id='tipo'
                            onChange={this.onChangeTipo}
                            name='tipo'>
                            <option>Seleccionar</option>
                            <option value='FIJOS'>Sueldo Fijo</option>
                            <option value='PROD'>Producción</option>
                            <option value='INFORMALES'>Informales</option>
                        </select>
                        {errors.tipo && (
                            <small className='help-blockParams form-Text'>
                                {errors.tipo[0]}
                            </small>
                        )}
                    </div>
                </div>
                {tipo && (
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Tipo Empleados:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <Select
                                name='tipo_empleados'
                                defaultValue={{
                                    label: "Todos",
                                    value: "todos",
                                }}
                                onChange={this.onChangeEmpleados}
                                options={[
                                    {
                                        label: "Todos",
                                        value: "todos",
                                    },
                                    ...tiposSeleccionados,
                                ]}
                            />
                            {errors.tipo && (
                                <small className='help-blockParams form-Text'>
                                    {errors.tipo[0]}
                                </small>
                            )}
                        </div>
                    </div>
                )}

                <div className='row form-group'>
                    <div className='col col-md-4'>
                        <label className='label form-control-label'>
                            Periodo:
                        </label>
                    </div>
                    <div className='col col-md-8'>
                        <select
                            name='periodo'
                            className="form-control"
                            onChange={this.onChangePeriodo}
                            value={periodo}
                        >
                            <option value="mensual">Mensual</option>
                            <option value="quincenal">Quincenal</option>
                        </select>
                        {errors.periodo && (
                            <small className='help-blockParams form-Text'>
                                {errors.periodo[0]}
                            </small>
                        )}
                    </div>
                </div>

                <div className='row form-group'>
                    <div className='col col-md-4'>
                        <label className='label form-control-label'>
                            Fecha de Inicio:
                        </label>
                    </div>
                    <div className='col col-md-8'>
                        <input
                            type='date'
                            className='text-input form-control'
                            id='fecha_inicio'
                            name='fecha_inicio'
                            value={fecha_inicio}
                            onChange={this.onChangeDate}
                        />
                        {errors.fecha_inicio && (
                            <small className='help-blockParams form-Text'>
                                {errors.fecha_inicio[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-4'>
                        <label className='label form-control-label'>
                            Fecha de Cierre:
                        </label>
                    </div>
                    <div className='col col-md-8'>
                        <input
                            type='date'
                            className='text-input form-control'
                            id='fecha_cierre'
                            name='fecha_cierre'
                            onChange={this.onChangeDate}
                            value={fecha_cierre}
                        />
                        {errors.fecha_cierre && (
                            <small className='help-blockParams form-Text'>
                                {errors.fecha_cierre[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-4'>
                        <label className='label form-control-label'>
                            Nombre:
                        </label>
                    </div>
                    <div className='col col-md-8'>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='nombre'
                            name='nombre'
                            onChange={this.onChangeNombre}
                            value={nombre}
                        />
                        {errors.nombre && (
                            <small className='help-blockParams form-Text'>
                                {errors.nombre[0]}
                            </small>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Form;
